import asyncCaseCall from '../../../Action/CreateCase/createCase'

const twoColStyling = (leftCol, rightCol) =>
  `<span style="color: #666666; line-height: 1.2"><span style="display: inline-block; width: 200px; vertical-align: top; font-weight: bold">${leftCol}</span><span style="display: inline-block; width: calc(100% - 200px); vertical-align: top; word-wrap: break-word">${rightCol}</span></span>`;

const configContents = ({
  state: {
    widgetName,
    langStrings,
    userSession,
    currentCMDetails,
    newCmDetails,
    hasError,
    error,
    success
  },
  dispatch,
}) => {
  const widgetFullName = {
    gac: 'Get activation code',
    hula: 'Request a home use license',
    pv: 'Request a previous version',
    cm: 'Change contract manager',
    sc: 'Change software coordinator',
    ccna: 'Change Company Name or Address',
  }[widgetName];
  let currentError;

  if (hasError.authEmail)
    currentError = langStrings
      ? langStrings.errors.emailNotAssocWithSerialNumber
      : "This email isn’t associated with the contract number above.";
  else if(hasError.contractNumberError)
    currentError = langStrings
      ? langStrings.cm.errors.contractNumNotFound
      : 'Contract number not found';
  else if(hasError.fName)
    currentError = langStrings
      ? langStrings.errors.enterFirstName
      : 'Enter your first name';
  else if(hasError.lName)
    currentError = langStrings
      ? langStrings.errors.enterLastName
      : 'Enter your last name';
  else if (hasError.invalidEmail || hasError.newCMEmail || hasError.currentCM)
    currentError = langStrings
      ? langStrings.errors.enterValidFormat
      : 'Enter a valid format';

  if (error)
    currentError = error.errorMessage;

  const caseDisplay = [
    {
      isTitle: true,
      description: langStrings
        ? langStrings[widgetName].welcome.modalTitle
        : widgetFullName,
      id: 'adsk-page-title',
      paragraphStyle: {
        marginBottom: currentError && '-25px'
      }
    },
    {
      BGColor: '#f7f7f7',
      description: langStrings
        ? langStrings.contactOptions.caseDetails
        : 'Case details',
      style: { fontSize: '16px', fontWeight: 'bold' },
    },
    {
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.contactInfoScreen.nameLabel : 'Name',
        `${userSession.first} ${userSession.last}`,
      ),
    },
    {
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.contactInfoScreen.emailTitle : 'Email',
        userSession.email,
      ),
    },
  ];

  if (currentCMDetails && currentCMDetails.contractNumber) {
    caseDisplay.push(
      {
        BGColor: '#f7f7f7',
        BGPadding: '0px 20px 8px',
        description: twoColStyling(
          langStrings ? langStrings.processInfoScreen.contractNumLabel : 'Contract number',
          `${currentCMDetails.contractNumber}`,
        ),
      },
    );
  }

  if (currentCMDetails && currentCMDetails.authEmail && !success) {
    caseDisplay.push(
      {
        BGColor: '#f7f7f7',
        BGPadding: '0px 20px 8px',
        description: twoColStyling(
          langStrings ? langStrings.cm.processInfoScreen.currentCmEmailLabel : 'Current contract manager’s email',
          `${currentCMDetails.authEmail}`,
        ),
      },
    );
  }

  if (newCmDetails && newCmDetails.firstName && newCmDetails.lastName && !success) {
    caseDisplay.push(
      {
        BGColor: '#f7f7f7',
        BGPadding: '0px 20px 8px',
        description: twoColStyling(
          langStrings ? langStrings.cm.processInfoScreen.newCmNameLabel : 'New contract manager’s name',
          `${newCmDetails.firstName} ${newCmDetails.lastName}`,
        ),
      },
    );
  }

  if (newCmDetails && newCmDetails.email && !success) {
    caseDisplay.push(
      {
        BGColor: '#f7f7f7',
        BGPadding: '0px 20px 8px',
        description: twoColStyling(
          langStrings ? langStrings.cm.processInfoScreen.newCmEmailLabel : 'New contract manager’s email',
          `${newCmDetails.email}`,
        ),
      },
    );
  }

  if (currentError) {
    caseDisplay.push(
      {
        BGColor: '#f7f7f7',
        BGPadding: '0px 20px 8px',
        description: twoColStyling(
          langStrings ? langStrings.contactOptions.errorLabel : 'Error',
          `${currentError}`,
        ),
      },
    );
  }

  caseDisplay.push(
    {
      description: langStrings
        ? langStrings.contactOptions.addtlCommentsReqd
        : 'Description',
      style: { fontSize: '14px', fontWeight: 'bold' },
      paragraphStyle: {
        marginTop: currentError ? '10px' :'15px',
        marginRight: '0px',
        marginLeft: '0px',
        marginBottom: '8px'
      },
      endWithRedStar: true,
    },
  );

  caseDisplay.push(
    {
      isTextArea: true,
      showWordCount: true,
      placeholder: langStrings
        ? langStrings.contactOptions.addtlCommentsMsg
        : 'Tell us any details we should know.',
      handleChange: (e) =>
        dispatch({ type: 'ENTER_CASE_DESCRIPTION', payload: e.target.value }),
    },
  );

  return caseDisplay;
};

const configFooter = ({
  state: {
    credentials,
    hasExtension,
    langStrings,
    userSession,
    caseDescription,
    currentCMDetails,
    newCmDetails,
    error,
  },
  dispatch,
}) => ({
  hasQuestion: false,
  hasExtension,
  nextButtonContent: langStrings ? langStrings.buttons.submitButton : 'SUBMIT',
  enableNextButton: caseDescription.length > 0,
  handleNext: async () =>
    await asyncCaseCall(
      dispatch,
      userSession,
      caseDescription,
      currentCMDetails,
      newCmDetails,
      error,
      credentials,
    ),
  handleBack: () => {
    dispatch({ type: 'GO_TO_PREV_PAGE' })
    // Make sure user can see the scroll effect when they click back button from CreateCase page
    dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' })
    setTimeout(() => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }), 0)
  },
})

export default {
  configContents,
  configFooter,
};
